import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import Pill from '../../../../Pill'
import { FACT_LABEL_TOOLTIP_DELAY, FACT_LABEL_TOOLTIP_MIN_WIDTH } from '../../../constants'

class AttributeMultiSelectPill extends PureComponent {
  render () {
    return (
      <Pill
        onSelect={this.props.onClick}
        isSelected={this.props.isSelected}
        text={this.props.label}
        tooltip={this.props.definition}
        toolTipMinWidth={FACT_LABEL_TOOLTIP_MIN_WIDTH}
        toolTipHoverDelay={FACT_LABEL_TOOLTIP_DELAY}
        toolTipShowPointer={false}
        toolTipPosition="right"
      />
    )
  }
}

AttributeMultiSelectPill.propTypes = {
  isSelected: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  definition: PropTypes.string.isRequired
}
export default AttributeMultiSelectPill
